import { IncomingHttpHeaders } from 'http';
import { AbTestResumeScreeningScoreFilteringResponse } from '@doda/api-client/aspida/@types';
import { apiClient } from '@doda/api-client/util/apiClient';

/**
 * ABテスト振分け用グループNo取得API（DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント）へのリクエスト
 * @param headers
 * @returns {AbTestResumeScreeningScoreFilteringResponse} ABテスト振分け用グループNo
 */
export const getAbTestResumeScreeningScoreFilteringGroupNo = (
  headers?: IncomingHttpHeaders
): Promise<AbTestResumeScreeningScoreFilteringResponse> => {
  return apiClient.api.v1.abtests.resumeScreeningScoreFiltering.$get({
    config: { headers },
  });
};
